import {Navbar} from '@common/ui/navigation/navbar/navbar';
import {SearchAutocomplete} from '@app/search/search-autocomplete';
import clsx from 'clsx';
import {IconButton} from '@common/ui/buttons/icon-button';
import {SearchIcon} from '@common/icons/material/Search';
import {Link} from 'react-router-dom';
import {Tooltip} from '@common/ui/tooltip/tooltip';
import {Trans} from '@common/i18n/trans';
import {SearchNormal} from 'iconsax-react';
import {useSelectedLocale} from '@common/i18n/selected-locale';

interface Props {
  position?: 'fixed' | 'relative';
}
export function MainNavbar({position = 'relative'}: Props) {
  const {locale} = useSelectedLocale();

  return (
    <Navbar
      size="lg"
      menuPosition="primary"
      className={clsx(position, 'z-40 w-full flex-shrink-0')}
      border="border-none"
      alwaysDarkMode
    >
      <Tooltip label={<Trans message="Search" />}>
        <IconButton
          elementType={Link}
          to="/search"
          className={clsx(
            'md:hidden',
            locale.language === 'fa' ? 'mr-auto' : 'ml-auto',
          )}
          iconSize="md"
        >
          <SearchNormal className="h-24 w-24" color="#d9e3f0" />
        </IconButton>
      </Tooltip>
      <SearchAutocomplete className="mx-2 min-w-[360px] max-md:hidden" />
    </Navbar>
  );
}
